<template>
  <div>
    <HomePage />
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import HomePage from '../components/Home/HomePage';

export default {
  components: {
    HomePage,
  },
  mixins: [global],
  head() {
    const metaTitle = 'Free Statistics Calculators';
    const metaDescription = 'Free online statistics calculators and tables for confidence intervals, p-values, standard deviation, descriptive statistics, and more. Fast, accurate, and built by experts.';
    const fullPath = `${this.$config.calculatorsUrl}${this.$route.fullPath}`;

    return {
      titleTemplate: `${metaTitle}%s`,
      meta: this.metaProps({ metaTitle, metaDescription, fullPath }),
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
    };
  },
};
</script>
